import React, { useContext, useEffect, useState } from "react"
import * as AppConstants from "../../utility/AppConstants"
import { useHistory } from "react-router-dom"
import save from "save-file"
// REST
import axios from "axios"
// TAB

import Breadcrumb from "../breadcrumb/Breadcrumb"
import { generaSVGGrafico } from "../../utility/Utility"
import NotaMetodologicaPDF from "../../../pdf/NTM_Internet_Multianno.pdf"
import TabNazionaliMultiAnno from "../tab/nazionali/multiAnno/TabNazionaliMultiAnno"
import {
    MultiAnnoPieKeys,
    ResponseDatiNazionaliMultiAnno
} from "@/utility/model"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
interface DatiNazionaliProps {
    anno: string
    codIsa?: string
    macroarea?: string
    tipologia?: string
}

function DatiNazionaliMultiAnno(props: DatiNazionaliProps) {
    const history = useHistory()
    const [pdfDisabled, setPdfDisabled] = useState(false)
    const [excelDisabled, setexcelDisabled] = useState(false)
    const [datiNazionali, setDatiNazionali] = useState<
        ResponseDatiNazionaliMultiAnno[]
    >([])
    const [macroareeTerritoriali, seMacroareeTerritoriali] = useState([{},{},{}])

    const [respDatiNazionali, setRespDatiNazionali] = useState(false)
    const [respAreeTerritoriali, setRespAreeTerritoriali] = useState(false)

    const [rangeAnni, setRangeAnni] = useState<
        { value: string; label: string }[]
    >([])

    const [multiAnnoState, multiAnnoDispatch] = useContext(MultiAnnoContext)

    let codiciIsa = datiNazionali.map((e) => e.codIsa)

    

    useEffect(() => {
        const url = AppConstants.URL_GET_DATI_NAZIONALI_MULTI_ANNO
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        let macroArea =
            props.macroarea == undefined || props.macroarea == ""
                ? "@@"
                : props.macroarea

        let codiceIsa =
            props.codIsa == undefined || props.codIsa == ""
                ? "@@"
                : props.codIsa
        axios
            .get(url, {
                params: {
                    anno: props.anno,
                    codIsa: codiceIsa,
                    macroarea: macroArea,
                    natGiuridica: "0",
                    cancelToken: source.token
                }
            })
            .then((response) => {
                if (response.data.length > 0) {
                    setDatiNazionali(response.data)
                    setRespDatiNazionali(true)


                    let range: number[] = response.data.map(
                        (el: ResponseDatiNazionaliMultiAnno) => el.anno
                    )

                    let val = {
                        value: range[0].toString(),
                        label: `${range[0]} - ${range[2]}`
                    }
                    setRangeAnni((prevState) => {
                        let cp = [...prevState]
                        cp.push(val)
                        return cp
                    })

                    multiAnnoDispatch({
                        type: "setTotale",
                        value: {
                            totale: (
                                response.data as ResponseDatiNazionaliMultiAnno[]
                            ).map((d) => ({
                                numeroPosizioni: d.numPosizioni.toString(),
                                anno: d.anno
                            }))
                        }
                    })
                } 
            })
            .catch((err) => {
                console.log("err: ", err)
            })

        return () => source.cancel()
    }, [props, history])

    useEffect(() => {
        const urlAreeTerritoriali = AppConstants.URL_GET_MACROAREE_TERRITORIALI

        const CancelToken = axios.CancelToken
        const source = CancelToken.source()

        if (
            props.codIsa !== null &&
            props.codIsa !== undefined &&
            respDatiNazionali
        ) {
            let infoCod =
                props.codIsa != "@@" &&
                props.codIsa != "" &&
                [...new Set(codiciIsa)].length > 1
                    ? codiciIsa
                    : ["", "", ""]

            axios
                .get(urlAreeTerritoriali, {
                    params: {
                        anno: props.anno,
                        codIsa: props.codIsa,
                        macroarea: props.macroarea,
                        cancelToken: source.token
                    }
                })
                .then((response) => {
                    seMacroareeTerritoriali((arr) => {
                        if (arr != null) {
                            return [ response.data,arr[1],arr[2]]
                        } else {
                            return response.data
                        }
                    })
                    setRespAreeTerritoriali(true)
                })
                .catch((err) => {
                    console.log("error: ", err)
                })

            axios
                .get(urlAreeTerritoriali, {
                    params: {
                        anno: Number(props.anno) + 1,
                        codIsa: infoCod[1],
                        macroarea: props.macroarea,
                        cancelToken: source.token
                    }
                })
                .then((response) => {
                    seMacroareeTerritoriali((arr) => {
                        if (arr != null) {
                            return [arr[0], response.data, arr[2]]
                        } else {
                            return response.data
                        }
                    })
                    setRespAreeTerritoriali(true)
                })
                .catch((err) => {
                    console.log("error: ", err)
                })

            axios
                .get(urlAreeTerritoriali, {
                    params: {
                        anno: Number(props.anno) + 2,
                        codIsa: infoCod[2],
                        macroarea: props.macroarea,
                        cancelToken: source.token
                    }
                })
                .then((response) => {
                    seMacroareeTerritoriali((arr) => {
                        if (arr != null) {
                            return [arr[0], arr[1], response.data]
                        } else {
                            return response.data
                        }
                    })
                    setRespAreeTerritoriali(true)
                })
                .catch((err) => {
                    console.log("error: ", err)
                })
        } else {
            setRespAreeTerritoriali(true)
        }

        return () => source.cancel()
    }, [respDatiNazionali])
    function getTitle(
        props: Omit<
            DatiNazionaliProps,
             "tipologia" | "anno"
        >
    ) {
        let title = "Dati Nazionali "
        if (props.codIsa !== null && props.codIsa !== undefined)
            title += "Codici ISA"
        else if (props.macroarea !== null && props.macroarea !== undefined)
            title += "Macrosettori"
        else title += "ISA"
        return title
    }

    let title = getTitle(props) 

    return (
        <div className="main-min-vh" role="main">
            <div className="container-fluid py-3 py-md-4">
                <Breadcrumb voce={title} />

                <div className="row">
                    <div className="col-auto">
                        <h1>
                            {title}
                        </h1>
                    </div>

                    <div className="col">&nbsp;</div>

                    <div className="col-auto">
                        {respDatiNazionali && respAreeTerritoriali ? (
                            <button
                                // rel="noopener noreferrer"
                                type="button"
                                title="Download EXCEL Dati Nazionali"
                                style={{
                                    borderWidth: 0,
                                    color: "#06c",
                                    opacity: excelDisabled ? 0.6 : 1,
                                    backgroundColor: "transparent"
                                }}
                                disabled={excelDisabled}
                                onClick={(e) =>
                                    !multiAnnoState.isMultiAnno
                                        ? downloadExcelDatiNazionali(props, e)
                                        : downloadExcelDatiNazionaliMA(
                                              props,
                                              e,
                                              setexcelDisabled
                                          )
                                }
                            >
                                <i className="fas fas fa-file-excel fa-3x mr-2"></i>
                            </button>
                        ) : (
                            <React.Fragment />
                        )}

                        {respDatiNazionali && respAreeTerritoriali ? (
                            <button
                                type="button"
                                title="Download PDF Dati Nazionali"
                                style={{
                                    borderWidth: 0,
                                    color: "#06c",
                                    opacity: pdfDisabled ? 0.6 : 1,
                                    backgroundColor: "transparent"
                                }}
                                disabled={pdfDisabled}
                                onClick={(e) =>
                                    !multiAnnoState.isMultiAnno
                                        ? downloadPDFDatiNazionali(props, e)
                                        : downloadPDFDatiNazionaliMA(
                                              props,
                                              e,
                                              setPdfDisabled
                                          )
                                }
                            >
                                <i className="fas fas fa-file-pdf fa-3x mr-2"></i>
                            </button>
                        ) : (
                            <React.Fragment />
                        )}
                    </div>

                    <div className="col-auto">
                        <a
                            href={
                                NotaMetodologicaPDF
                                // process.env.CONTEXT_PATH +
                                // "/public/resources/pdf/Nota_Metodologica.pdf"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Nota Metodologica"
                        >
                            <span className="fas fa-info-circle fa-3x mr-2"></span>
                        </a>
                    </div>
                </div>
                {respDatiNazionali && respAreeTerritoriali ? (
                    <TabNazionaliMultiAnno
                        datiNazionali={datiNazionali}
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        macroareeTerritoriali={macroareeTerritoriali}
                        anno={props.anno}
                    />
                ) : (
                    <React.Fragment />
                )}
            </div>
        </div>
    )
}

function appendBlob(
    formData: FormData,
    element: HTMLCanvasElement | null,
    index: number
) {
    //ctx?.forEach((e:any) => e?.draw())
    return new Promise<void>((resolve, reject) => {
        element?.toBlob(async (blob) => {
            if (blob != null) {
                formData.append("fileNazionali" + (index + 1).toString(), blob)
                console.log("append graph " + (index + 1))

                resolve()
            } else {
                resolve()
            }
        }, "image/jpeg")
    })
}

async function downloadPDFDatiNazionaliMA(
    props: DatiNazionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,

    action: (f: boolean) => void
) {
    e.preventDefault()
    action(true)
    let nomePDF = `datiNazionali_${props.anno}_${Number(props.anno) + 2}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName(
        "NazionaliChart_ChartJs"
    ) as HTMLCollectionOf<HTMLCanvasElement>
    const formData = new FormData()
    formData.append("anno", props.anno)

    let macroArea = macroarea == undefined || macroarea == "" ? "@@" : macroarea

    let codiceIsa = codIsa == undefined || codIsa == "" ? "@@" : codIsa

    formData.append("codIsa", codiceIsa)

    formData.append("macroarea", macroArea)

    for (let i = 0; i < regionChart.length; i++) {
        const element = regionChart.item(i)
        await appendBlob(formData, element, i)
    }

    console.log("done")

    axios
        .post(AppConstants.URL_GET_PDF_DATI_NAZIONALI_MA_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
        })
        .catch((err) => {})
        .finally(() => action(false))
}
function downloadExcelDatiNazionali(
    props: DatiNazionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) {
    e.preventDefault()
    let nomeExcel = `datiNazionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    //$("#apri").click();

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "filePie",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("pie_chart") as Node
            )
        )
    )
    formData.append(
        "fileBar",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("bar_chart") as Node
            )
        )
    )

    //console.log((new XMLSerializer).serializeToString(document.getElementById('bar_chart')));

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_NAZIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
            //test(excelByte, nomeExcel);
            //console.log(excelByte);
        })
        .catch((err) => {
            //$("#chiudi").click();
        })
}

async function downloadExcelDatiNazionaliMA(
    props: DatiNazionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,

    action: (f: boolean) => void
) {
    e.preventDefault()
    action(true)
    let nomeExcel = `datiNazionali_${props.anno}_${Number(props.anno) + 2}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName(
        "NazionaliChart_ChartJs"
    ) as HTMLCollectionOf<HTMLCanvasElement>
    const formData = new FormData()
    formData.append("anno", props.anno)

    let macroArea = macroarea == undefined || macroarea == "" ? "@@" : macroarea

    let codiceIsa = codIsa == undefined || codIsa == "" ? "@@" : codIsa

    formData.append("codIsa", codiceIsa)

    formData.append("macroarea", macroArea)

    for (let i = 0; i < regionChart.length; i++) {
        const element = regionChart.item(i)
        await appendBlob(formData, element, i)
    }

    console.log("done")

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_NAZIONALI_MA_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
        })

        .catch((err) => {})
        .finally(() => action(false))
}

function downloadPDFDatiNazionali(
    props: DatiNazionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) {
    e.preventDefault()
    let nomePDF = `datiNazionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    //$("#apri").click();

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "filePie",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("pie_chart") as Node
            )
        )
    )
    formData.append(
        "fileBar",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("bar_chart") as Node
            )
        )
    )

    //console.log(props.anno,macroarea,codIsa);
    axios
        .post(AppConstants.URL_GET_PDF_DATI_NAZIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
            //$("#chiudi").click();
        })
        .catch((err) => {
            //$("#chiudi").click();
        })
}

export default DatiNazionaliMultiAnno
